import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useContext } from 'react';
import AuthContext from '../../context/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';

const AuthLayout = () => {
  const { isAuthenticated, loading } = useContext(AuthContext);
  const location = useLocation();
  
  // If already authenticated, redirect to dashboard
  if (!loading && isAuthenticated) {
    // Redirect to the page they were trying to access, or to dashboard
    const from = location.state?.from?.pathname || '/';
    return <Navigate to={from} replace />;
  }
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-primary">
            Fleet Tracker
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Real-time Location Intelligence System
          </p>
        </div>
        
        <div className="bg-white shadow-md rounded-lg p-8">
          {loading ? (
            <div className="py-8">
              <LoadingSpinner size="large" />
              <p className="text-center mt-4 text-gray-600">Loading...</p>
            </div>
          ) : (
            <Outlet />
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;